<template>
    <div>
        <headerNotice routerName="订单拣货"></headerNotice>
        <!-- 搜索栏 -->
        <div class="searchBox">
            <el-row :gutter="24">
                <!-- 搜索框 -->
                <el-col :span="5" :offset="0">
                    <el-input placeholder="请输入单号/用户昵称/手机号" v-model="serachForm.keyword">
                        <el-button slot="append" icon="el-icon-search" @click="serachIt"></el-button>
                    </el-input>
                </el-col>
                <!-- 区域搜索 -->
                <el-col :span="4" :offset="0">
                    <el-cascader
                        ref="regin"
                        v-loading="regionLoading"
                        placeholder="地址搜索"
                        :options="AllAreaOptions"
                        :props="cascaderProps"
                        @change="AreaHandleChange"
                        change-on-select
                    ></el-cascader>
                </el-col>
                <!-- 打印状态搜索 -->
                <el-col :span="3" :offset="0">
                    <el-select
                        v-model="printStatus"
                        @change="printChangeStatus"
                        placeholder="请选择打印状态"
                    >
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="快递单未打印" :value="1"></el-option>
                        <el-option label="快递单已打印" :value="2"></el-option>
                        <el-option label="发货单未打印" :value="3"></el-option>
                        <el-option label="发货单已打印" :value="4"></el-option>
                        <el-option label="全部已打印" :value="5"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="3" :offset="0">
                    <el-button type="primary" @click="searchDialog=true">
                        <i class="el-icon-search"></i> 高级搜索
                    </el-button>
                  
                </el-col>
            </el-row>
        </div>
        <!-- 数据表格 -->
        <div class="dataTable" v-loading="loading">
            <!-- 多选操作 -->
            <div style="margin-top: 20px;margin-bottom:20px;">
                <span class="notice" v-if="choosedItem.length">
                    已经选择
                    <i>{{choosedItem.length}}</i> 项
                </span>
                <el-button type="primary" @click="batchAuditOrder">标记异常</el-button>
                <el-button type="primary" @click="batchShipPrint">打印发货单</el-button>
                <el-button type="primary" @click="modifyLogistics">修改发货仓库、物流</el-button>
                <!-- <el-button type="primary">打印快递单</el-button> -->
                <el-button type="primary" @click="printElectronicSheet">打印电子面单</el-button>
                <el-button type="primary" @click="bulkShipment">发货确认</el-button>
                 <el-button type="primary" @click="CusConfirmationBatch">定制确认</el-button>
                 <el-button type="primary" @click="ExportOrder">导出订单</el-button>
                <el-select
                    class="printTypeStatus"
                    v-model="printTypeStatus"
                    :disabled="printStatusDisabled"
                    placeholder="标记发货单打印"
                    @change="printStatusChange"
                >
                    <el-option :value="0" label="选择打印状态" disabled>选择打印状态</el-option>
                    <el-option :value="1" label="标记发货单已打印">标记发货单已打印</el-option>
                    <el-option :value="2" label="标记快递单已打印">标记快递单已打印</el-option>
                    <el-option :value="3" label="取消发货单已打印">取消发货单已打印</el-option>
                    <el-option :value="4" label="取消快递单已打印">取消快递单已打印</el-option>
                </el-select>
            </div>
            <el-table
                size="mini"
                :row-style='{"font-size": "14px"}'
                class="tableBox"
                :data="orderList"
                style="width: 100%"
                :default-sort="{prop: 'date', order: 'descending'}"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column align="center" label="单号">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.agent>0">代</el-tag>
                        <span
                            class="orderCode"
                            @click="watchOrderDetail(scope.row)"
                        >{{scope.row.orderCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="customer" label="用户昵称"></el-table-column>
                <el-table-column
                    align="center"
                    prop="disAmount"
                    label="订单金额（￥）"
                    width="150"
                    sortable
                ></el-table-column>
                <el-table-column align="center" prop="unit" label="单据状态" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.orderStatus==1" style="color:#f63b3b;">待付款</span>
                        <span v-if="scope.row.orderStatus==3" style="color:#f63b3b;">待审核</span>
                        <span v-if="scope.row.orderStatus==4" style="color:#f63b3b;">配货中</span>
                        <span v-if="scope.row.orderStatus==16" style="color:#f63b3b;">配货中</span>
                        <span v-if="scope.row.orderStatus==5" style="color:#f63b3b;">订单异常</span>
                        <span v-if="scope.row.orderStatus==7" style="color:#f63b3b;">待发货</span>
                        <span v-if="scope.row.orderStatus==8" style="color:#f63b3b;">待收货</span>
                        <span v-if="scope.row.orderStatus==10">已完成</span>
                        <span v-if="scope.row.orderStatus==14">已关闭</span>
                    </template>
                </el-table-column>
                 <el-table-column align="center" prop="stock" label="定制状态" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isCustomized==1" style="color:#f63b3b;">
                            <span v-if="scope.row.orderStatus==4" style="color:#f63b3b;">未定制</span>
                            <span v-if="scope.row.orderStatus==16" style="color:#f63b3b;">已定制</span>
                        </span>
                         <span v-else style="color:#f63b3b;"></span> 
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="stock" label="财务状态" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.payStatus==1">已付款</span>
                        <span v-else style="color:#f63b3b;">未付款</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="orderPerson" label="制单人" width="100"></el-table-column>
                <el-table-column align="center" prop="payTime" label="提交时间" width="100" sortable></el-table-column>
                <el-table-column align="center" prop="remark" label="订单备注"></el-table-column>
                <!-- <el-table-column align="center" label="打印状态" width="100" sortable>
                    <template slot-scope="scope">
                        <span v-if="scope.row.printStatus==0" style="color:#f63b3b;">未打印</span>
                        <span v-if="scope.row.printStatus==1" style="color:#f63b3b;">发货单已打印</span>
                        <span v-if="scope.row.printStatus==2" style="color:#f63b3b;">快递单已打印</span>
                        <span v-if="scope.row.printStatus==3">已打印</span>
                    </template>
                </el-table-column>-->
                <el-table-column align="center" label="快递单状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.expressPrintStatus==0" style="color:#f63b3b;">未打印</span>
                        <span v-if="scope.row.expressPrintStatus==1">已打印</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="发货单状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.shippingPrintStatus==0" style="color:#f63b3b;">未打印</span>
                        <span v-if="scope.row.shippingPrintStatus==1">已打印</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button @click="watchOrderDetail(scope.row)" size="small">查看</el-button>
                        <el-button @click="modifyAddress(scope.row)" size="small">修改收货地址</el-button>
                        <el-button v-if="scope.row.isCustomized==1 &&scope.row.orderStatus==4"  @click="CusConfirmation(scope.row)" size="small">定制确认</el-button>
                    </template> 
                     
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[25, 50, 75, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>

        <!-- 高级搜索dialog框 -->
        <el-dialog title="高级搜索" class="searchDialog" :visible.sync="searchDialog" width="70%">
            <el-form :model="serachForm" class="signUp_Form" label-width="125px">
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="单号">
                            <el-input
                                v-model="serachForm.orderCode"
                                placeholder="请输入订单编号"
                                clearable
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="收货人">
                            <el-input
                                v-model="serachForm.customer"
                                placeholder="请输入收货人名称"
                                clearable
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="提交订单时间">
                            <el-date-picker
                                v-model="submitTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="商品名称">
                            <el-input
                                v-model="serachForm.title"
                                placeholder="请输入商品名称"
                                clearable
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="制单人">
                            <el-input
                                v-model="serachForm.orderPerson"
                                placeholder="请输入制单人"
                                clearable
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="订单备注">
                            <el-input
                                v-model="serachForm.remark"
                                placeholder="请输入订单备注"
                                clearable
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="10">
                        <el-form-item label="所属业务员">
                            <el-select v-model="serachForm.salesman" placeholder="请选择商品标签">
                                <el-option label="全部" :value="0"></el-option>
                                <el-option
                                    v-for="item in salesmanList"
                                    :key="item.userId"
                                    :label="item.realName"
                                    :value="item.userId"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <!-- <el-row>
                    <el-col class="sale" :span="10">
                        <el-form-item label="下单方式">
                            <el-radio-group v-model="serachForm.agent">
                                <el-radio :label="0">自主下单</el-radio>
                                <el-radio :label="1">代客下单</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row> -->
            </el-form>
            <div class="searchDialogBtn">
                <el-button @click="clearSerachForm">清空</el-button>
                <el-button class="dialogConfirmBtn" @click="searchDialogConfirm" type="primary">确认</el-button>
            </div>
        </el-dialog>

        <!-- 批量标记异常订单dialog框 -->
        <el-dialog title="批量标记异常订单" class="auditDialog" :visible.sync="setVerifyDialog" width="30%">
            <el-form :model="auditForm" class="signUp_Form" label-width="125px">
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="备注：" :rules="[{'required':true}]">
                            <el-input
                                type="textarea"
                                maxlength="100"
                                placeholder="请输入备注，备注内容不能超过100个字"
                                :autosize="{minRows: 6 }"
                                clearable
                                v-model="auditForm.remark"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="btnBox">
                    <el-button @click="cancelAudit">取消</el-button>
                    <el-button @click="confirmAudit" type="primary">确认</el-button>
                </div>
            </el-form>
        </el-dialog>

        <!-- 修改收货地址单dialog框 -->
        <el-dialog
            title="修改收货地址"
            class="modifyAddressDialog"
            :visible.sync="modifyAddressDialog"
            width="40%"
            v-loading="modifyAddressDialogloading"
        >
            <el-form class="signUp_Form" label-width="125px">
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="客户名称" :rules="[{'required':true}]">
                            <el-input
                                placeholder="请输入客户名称"
                                clearable
                                v-model="addressItem.customer"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="联系人" :rules="[{'required':true}]">
                            <el-input
                                placeholder="请输入联系人"
                                clearable
                                v-model="addressItem.recipient"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="联系方式" :rules="[{'required':true}]">
                            <el-input placeholder="请输入联系方式" clearable v-model="addressItem.phone"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item
                            label="省/市/区"
                            :rules="[{'required':true}]"
                            v-loading="regionLoading"
                        >
                            <el-cascader
                                ref="cascaderAddr"
                                class="cascaderBox"
                                :options="reginData"
                                :props="cascaderProps"
                                v-model="addressItem.areaCode"
                            ></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="详细地址" :rules="[{'required':true}]">
                            <el-input placeholder="请输入详细地址" clearable v-model="addressItem.address"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="btnBox">
                    <el-button @click="cancelAudit">取消</el-button>
                    <el-button @click="confirmModify" type="primary">确认</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
import Bolb from './../../assets/js/Bolb.js'
import Export2Excel from './../../assets/js/Export2Excel.js'
export default {
    data() {
        return {
            baseUrl: this.$store.state.apiUrl,
            loading: true,
            totalCount: 0,//总数据条数
            maxResultCount: 25, //默认一页显示的个数,
            currentPage: 1,
            orderList: [],//商品列表主数据
            searchDialog: false,//高级搜索弹框显示是否
            submitTime: [],
            salesmanList: [],//业务员列表
            printStatus: 0,
            serachForm: {//高级搜索弹框数据
                'keyword': '',
                'status': null,
                'orderCode': null,
                'customer': '',
                'startTime': '',
                'endTime': '',
                'title': '',
                'orderPerson': '',
                'salesman': 0,
                'remark': '',
                "orderStatus":  [4,16],
                "orderType": 0,
                'areaCode': '',
                'cityName': '',
                'provinceName': ''
            },
            sorteHouseDialog: false,//是否显示库存详情弹框
            currentCheckItemID: 0,//当前准备设置标签的itemID
            choosedItem: [],//已选择的商品列表
            setVerifyDialog: false,//批量审核订单弹框
            auditForm: {
                remark: ''
            },//审核表单
            modifyAddressDialog: false,//是否显示修改地址弹框
            modifyAddressDialogloading: true,
            addressItem: {
                "customer": 0,
                "recipient": "",
                "phone": "",
                "detailAddr": 0,
                "provinceCode": "",
                "cityCode": "",
                "areaCode": [],
                "provinceName": "",
                "cityName": "",
                "areaName": "",
                "address": ""
            },
            regionLoading: true,
            reginData: [],
            cascaderProps: {
                children: "children",
                label: "name",
                value: "code"
            },
            printTypeStatus: 0,//标记打印状态
            printStatusDisabled: true,
            AllAreaOptions: [],
            cateProps: {
                value: 'cateID',
                label: 'cateName',
                children: 'cates',
            },
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
            Status: 0,
            orderStatus: [4,16],
            areaCode: this.serachForm.areaCode,
            cityName: this.serachForm.cityName,
            provinceName: this.serachForm.provinceName
        })
        this.getSalesmanList();
        this.getAllRegin();
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/PostOrderList",
                data: params,
                success(res) {
                    self.orderList = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //获取业务员列表
        getSalesmanList() {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSalesman/GetList",
                params: {
                    MaxResultCount: 999
                },
                success(res) {
                    self.salesmanList = res.items;
                },
                fail(res) {
                }
            })
        },
        //获取所有省市区数据
        getAllRegin() {
            let self = this;
            self.regionLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl + "/api/services/app/Province/GetAllRegion",
                success(res) {
                    self.reginData = res;
                    let allRegin = {
                        name:'全部',
                        code:null,
                        children:[]
                    }
                    
                    self.AllAreaOptions = [allRegin,...res];
                    self.regionLoading = false;
                },
                fail(res) {
                    self.regionLoading = false;
                }
            });
        },
        //名字 编号等搜索
        serachIt() {
            this.getDatas({
                MaxResultCount: this.maxResultCount,
                Status: 0,
                keyword: this.serachForm.keyword,
                orderStatus: [4,16],
                areaCode: this.serachForm.areaCode,
                cityName: this.serachForm.cityName,
                provinceName: this.serachForm.provinceName
            })
            this.currentPage = 1
        },
        // 根据打印状态搜索
        printChangeStatus(val) {
            this.serachForm.printStatus = val;
            this.getDatas({
                MaxResultCount: this.maxResultCount,
                Status: 0,
               orderStatus: [4,16],
                printStatus: val,
                areaCode: this.serachForm.areaCode,
                cityName: this.serachForm.cityName,
                provinceName: this.serachForm.provinceName
            })
        },
        //高级搜索dialog弹框
        advancedSearch() {
            this.searchDialog = true;
        },
        //清空高级搜索数据
        clearSerachForm() {
            this.submitTime = [];
            this.serachForm = {//高级搜索弹框数据
                'keyword': '',
                'status': null,
                'orderCode': null,
                'customer': '',
                'startTime': '',
                'endTime': '',
                'title': '',
                'orderPerson': '',
                'salesman': 0,
                'remark': '',
                "orderStatus": [4,16],
                "agent": null,
                'provinceName': '',
                'cityName': '',
                'areaCode': '',
                'printStatus':0,
            };
        },
        //高级搜索确认
        searchDialogConfirm() {
            let params = this.serachForm;
            if (this.submitTime.length) {
                let startTime = this.submitTime[0];
                let endTime = this.submitTime[1];
                params.startTime = startTime;
                params.endTime = endTime;
            }
            params.MaxResultCount = this.maxResultCount;
            this.searchDialog = false;
            this.getDatas(params);
            this.currentPage = 1
        },
        //查看订单
        watchOrderDetail(row) {
            this.$router.push({
                'path': '/orderDetail',
                'query': {
                    orderCode: row.orderCode
                }
            })
        },
        //修改收货地址
        modifyAddress(row) {
            let self = this;
            this.modifyAddressDialog = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/GetOrderAddress",
                params: {
                    orderID: row.orderID
                },
                success(res) {
                    let areaCode = [];
                    areaCode.push(Number(res.provinceCode));
                    areaCode.push(Number(res.cityCode));
                    areaCode.push(Number(res.areaCode));
                    self.addressItem = res;
                    self.addressItem.areaCode = areaCode;
                    self.modifyAddressDialogloading = false;
                },
                fail(res) {
                    self.modifyAddressDialogloading = false;
                }
            });
        },
        //修改收货地址 确定
        confirmModify() {
            let self = this;
            let cascaderAddrArr = this.$refs.cascaderAddr.currentLabels;
            if (cascaderAddrArr.length) {
                this.addressItem.provinceName = cascaderAddrArr[0];
                this.addressItem.cityName = cascaderAddrArr[1];
                this.addressItem.areaName = cascaderAddrArr[2];
            }
            if (this.addressItem.areaCode.length) {
                this.addressItem.provinceCode = this.addressItem.areaCode[0];
                this.addressItem.cityCode = this.addressItem.areaCode[1];
                this.addressItem.areaCode = this.addressItem.areaCode[2];
            }
            $http.PUT({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/UpdateOrderAddress",
                data: this.addressItem,
                success(res) {
                    self.$message({
                        message: '修改成功！',
                        type: 'success'
                    })
                    self.modifyAddressDialog = false;
                },
                fail(res) {
                }
            });
        },
        //勾选单个表格
        handleSelectionChange(val) {
            this.choosedItem = val;
            if (this.choosedItem.length) {
                this.printStatusDisabled = false;
            } else {
                this.printStatusDisabled = true;
            }
            this.$forceUpdate();
        },
        //批量标记异常订单点击
        batchAuditOrder() {
            let self = this;
            if (this.choosedItem.length) {
                this.setVerifyDialog = true;
            } else {
                this.$message.error('请先勾选要审核的订单！');
                return;
            }
        },
        //批量标记异常订单取消
        cancelAudit() {
            this.setVerifyDialog = false;
            this.modifyAddressDialog = false;
        },
        //批量标记异常订单确定
        confirmAudit() {
            let self = this;
            if (!this.auditForm.remark) {
                this.$message.error('请填写备注');
                return
            }
            this.setVerifyDialog = false;
            let orderIDArr = [];
            self.choosedItem.forEach((ele, index) => {
                orderIDArr.push(ele.orderID);
            })
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/AuditFailOrderVol",
                data: {
                    orderID: orderIDArr,
                    audit: self.auditForm.audit,
                    remark: this.auditForm.remark
                },
                success(res) {
                    self.$message({
                        type: 'success',
                        message: `操作成功！`
                    });
                    self.getDatas({
                        MaxResultCount: self.maxResultCount,
                        Status:  [4,16],
                        orderStatus: [],
                        areaCode: self.serachForm.areaCode,
                        cityName: self.serachForm.cityName,
                        provinceName: self.serachForm.provinceName
                    })
                    self.currentPage = 1
                    self.$forceUpdate();
                },
                fail(res) {

                }
            })

        },
        //批量发货确定
        bulkShipment() {
            let self = this;
            if (this.choosedItem.length) {
                for (let index = 0; index < this.choosedItem.length; index++) {
                    const element = this.choosedItem[index];
                    if (element.isCustomized==1&&element.orderStatus!=16) {//定制订单状态为16发货
                        self.$message.error('定制订单必须定制状态为已定制才能发货');
                        return;
                    }else if(element.isCustomized==0&&element.orderStatus!=4){//普通订单状态为4发货
                        self.$message.error('普通订单必须单据状态为配货中才能发货');
                        return;
                    }
                }
                let orderIDArr = [];
                self.choosedItem.forEach((ele, index) => {
                    orderIDArr.push(ele.orderID);
                })
                sessionStorage.setItem('orderIDArr', orderIDArr);
                this.$router.push({
                    'path': '/bulkShipment'
                })
            } else {
                this.$message.error('请先勾选要发货的订单！');
                return;
            }
        },
      //批量定制确定
        CusConfirmationBatch() {
           
            let self = this;
            if (this.choosedItem.length) {               
                let submitOrder = [];
                self.btnLoading = true;
                for (let index = 0; index < self.choosedItem.length; index++) {
                    const element = self.choosedItem[index];
                     //定制确认必须状态是未定制状态
                    if (element.orderStatus!=4) {
                        self.$message.error('定制确认的订单必须定制状态为未定制');
                        return;
                    }
                }
                self.choosedItem.forEach((ele, index) => {
                     submitOrder.push({
                        "orderID": ele.orderID,
                        "houseID": 0,
                        "logisticsID": 0,
                        "expressNo": 0
                })
                })
                $http.POST({
                    url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/CusConfirmation",
                    data: {
                        deliver: submitOrder
                    },
                    success(res) {
                        self.$message({
                            message: '确认定制成功！',
                            type: 'success'
                        });
                        self.getDatas({
                            MaxResultCount: self.maxResultCount,
                            Status: 0,
                            orderStatus: [4,16],
                            areaCode: self.serachForm.areaCode,
                            cityName: self.serachForm.cityName,
                            provinceName: self.serachForm.provinceName
                        });
                        
                    },
                   
                })
            } else {
                this.$message.error('请先勾选要确认的订单！');
                return;
            }
        },
       CusConfirmation(row) {
           debugger;
            let self = this;
            let submitOrder = [];
            submitOrder.push({
                        "orderID": row.orderID,
                        "houseID": 0,
                        "logisticsID": 0,
                        "expressNo": 0
                })
            $http.POST({
                    url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/CusConfirmation",
                    data: {
                        deliver: submitOrder
                    },
                    success(res) {
                        self.$message({
                            message: '确认定制成功！',
                            type: 'success'
                        });
                        self.getDatas({
                        MaxResultCount: self.maxResultCount,
                        Status: 0,
                        orderStatus: [4,16],
                        areaCode: self.serachForm.areaCode,
                        cityName: self.serachForm.cityName,
                        provinceName: self.serachForm.provinceName
                        });
                        self.currentPage = 1
                         self.$forceUpdate();
                    },
                   
                })
        },
        
        //修改发货仓库及物流
        modifyLogistics() {
            let self = this;
            if (this.choosedItem.length) {
                let orderIDArr = [];
                self.choosedItem.forEach((ele, index) => {
                    orderIDArr.push(ele.orderID);
                })
                sessionStorage.setItem('orderIDArr', orderIDArr);
                this.$router.push({
                    'path': '/modifyLogistics'
                })
            } else {
                this.$message.error('请先勾选要发货的订单！');
                return;
            }
        },
        //批量打印发货单
        batchShipPrint() {
            let self = this;
            if (this.choosedItem.length) {
                let orderIDArr = [];
                self.choosedItem.forEach((ele, index) => {
                    orderIDArr.push(ele.orderID);
                })
                sessionStorage.setItem('orderIDArr', orderIDArr);
                this.$router.push({
                    'path': '/batchShipPrint'
                })
            } else {
                this.$message.error('请先勾选要打印的快递订单！');
                return;
            }
        },
        //批量打印电子面单
        printElectronicSheet() {
            let self = this;
            if (this.choosedItem.length) {
                let orderIDArr = [];
                let orderStatusArr = []
                let printedNum = 0
                self.choosedItem.forEach((ele, index) => {
                    orderIDArr.push(ele.orderID);
                    orderStatusArr.push(ele.orderStatus)
                    if (ele.expressPrintStatus) printedNum++
                })
                sessionStorage.setItem('orderIDArr', orderIDArr);
                if (printedNum) {
                    this.$confirm("存在" + printedNum + "笔已打印订单, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                        .then(() => {
                            this.$router.push({
                                'path': '/electronicSheet'
                            })
                        })
                        .catch(() => { });
                } else {
                    this.$router.push({
                        'path': '/electronicSheet'
                    })
                }
                // let isNotPosted = orderStatusArr.some((ele) => {
                //     return ele == 4
                // })
                // if (isNotPosted) {
                //     self.$message.error('请只勾选已发货订单！')
                //     return
                // }          
            } else {
                this.$message.error('请先勾选要打印的快递订单！');
                return;
            }
        },
        //批量选择打印状态
        printStatusChange(val) {
            let self = this;
            if (val) {
                let orderIDArr = [];
                self.choosedItem.forEach((ele, index) => {
                    orderIDArr.push(ele.orderID);
                })
                $http.POST({
                    url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/AlterPrintStatusVol",
                    data: {
                        orderIds: orderIDArr,
                        status: val
                    },
                    success(res) {
                        self.$message({
                            message: '修改状态成功！',
                            type: 'success'
                        });
                        self.printStatusDisabled = true;
                        self.printTypeStatus = 0;
                        let params = self.serachForm;
                        params.MaxResultCount = self.maxResultCount;
                        params.Status = 0;
                        self.getDatas(params);
                    },
                    fail(res) {
                        self.printTypeStatus = 0;
                    }
                });
            } else {
                self.printTypeStatus = 0;
            }
        },
        //一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
                Status: 0,
                orderStatus:  [4,16],
            };
            this.getDatas(params);
        },
        //跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.serachForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getDatas(params);
        },
        //下拉选择省市事件
        AreaHandleChange(value) {
            let self = this;
            //获取对应lable
            let name = self.$refs.regin.currentLabels;
            self.serachForm.provinceName = name[0];
            self.serachForm.cityName = name[1];
            if(self.serachForm.provinceName == "全部"){
                self.serachForm.provinceName = "";
            }
            if( value.length==3){
                self.serachForm.areaCode = value[2];
            }
            self.getDatas({
                MaxResultCount: self.maxResultCount,
                Status: 0,
                orderStatus:  [4,16],
                provinceName: self.serachForm.provinceName,
                cityName: self.serachForm.cityName,
                areaCode: value[2],
                printStatus:this.serachForm.printStatus
            })
        },
        ExportOrder() {
            require.ensure([], () => {
                const { export_json_to_excel } = require("../../assets/js/Export2Excel"); //注意这个Export2Excel路径
                const tHeader = ["单号", "客户", "订单金额(￥)","单据状态","定制状态","财务状态","制单人","提交时间","订单备注","快递单状态","发货单状态"]; // 上面设置Excel的表格第一行的标题
                const filterVal = ["orderCode", "customer", "disAmount", "orderStatusshow", "customizationStatusshow", "caiwuStatusshow", "orderPerson", "createTime", "remark", "shippingPrintStatusshow","expressPrintStatusshow"]; // 上面的index、nickName、name是tableData里对象的属性key值
                const orderStatusobj = {1:'待付款',3:'待审核',4:'配货中',16:'配货中',5:'订单异常',7:'待发货',8:'待收货',10:'已完成',14:'已关闭',}
                const customizationStatusobj = {4:'未定制',16:'已定制'}
                const list = []; //把要导出的数据tableData存到list
                let orderList = this.orderList;
                for (let index = 0; index < orderList.length; index++) {
                    const element = orderList[index];
                    element.orderStatusshow =orderStatusobj[element.orderStatus];
                    element.customizationStatusshow = customizationStatusobj[element.orderStatus];
                    if (element.payStatus==1) {
                        element.caiwuStatusshow = "已付款";
                    }else{
                        element.caiwuStatusshow = "未付款";
                    }
                    if (element.shippingPrintStatus==1) {
                        element.shippingPrintStatusshow = "已打印";
                    }else{
                        element.shippingPrintStatusshow = "未打印";
                    }
                    if (element.expressPrintStatusshow==1) {
                        element.expressPrintStatusshow = "已打印";
                    }else{
                        element.expressPrintStatusshow = "未打印";
                    }
                    list.push(element);
                }
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, "导出订单"); //最后一个是表名字
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        }
    }
}
</script>

<style lang='scss' scoped>
// 搜索栏
.searchBox {
    padding: 20px;
}
// 数据表格
.dataTable {
    padding-bottom: 0;
    margin: 20px;
    .tableBox {
        border: 1px solid #c5c5c5;
        .orderCode {
            margin-left: 10px;
            cursor: pointer;
            &:hover {
                color: #409eff;
            }
        }
    }
    .goodBaseInfo {
        display: flex;
        align-items: center;
        .txtInfo {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            text-align: left;
            .title {
                font-size: 12px;
                color: #333;
            }
            .itemCode {
                font-size: 10px;
                color: #999;
            }
            .tags {
                display: flex;
                align-items: center;
                span {
                    height: 18px;
                    line-height: 18px;
                    font-style: normal;
                    font-size: 10px;
                    padding: 0px 8px;
                    color: #fff;
                    background: #999;
                    border-radius: 4px;
                    margin-right: 4px;
                }
                /deep/ .el-popover__reference {
                    cursor: pointer;
                    margin: 0;
                    padding: 0;
                }
            }
        }
        img {
            width: 100px;
            height: 100px;
            margin-right: 10px;
        }
    }
    .notice {
        display: inline-block;
        margin-right: 20px;
        i {
            font-style: normal;
            color: #f63b3b;
        }
    }
    .printTypeStatus {
        margin-left: 20px;
    }
}
//高级搜索Dialog框
.searchDialog {
    .sale {
        display: flex;
        align-items: center;
        span {
            display: block;
            width: 125px;
            text-align: right;
            box-sizing: border-box;
            padding-right: 12px;
        }
        input {
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            color: #606266;
            display: inline-block;
            font-size: inherit;
            height: 40px;
            line-height: 40px;
            outline: 0;
            padding: 0 15px;
            -webkit-transition: border-color 0.2s
                cubic-bezier(0.645, 0.045, 0.355, 1);
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            width: 100px;
            height: 32px;
            outline: #409eff;
            appearance: normal;
        }
    }
    .searchDialogBtn {
        text-align: center;
    }
}
//批量审核dialog框
.auditDialog {
    .btnBox {
        text-align: center;
    }
}
.modifyAddressDialog {
    .cascaderBox {
        width: 300px;
    }
    .btnBox {
        text-align: center;
    }
}
</style>
<style lang="scss">
.goodsListCheckBox {
    display: flex;
    flex-direction: column;
    label {
        margin-left: 0 !important;
    }
}
</style>